import { Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProcessosJudiciaisOcorrenciasService } from 'src/app/services/processos-judiciais-ocorrencias.service';
import { ProcessosJudiciaisService } from 'src/app/services/processos-judiciais.service';
import { ModalService } from 'src/app/services/shared/modal-service';
import { NgbDateCustomParserFormatter } from 'src/app/utils/dateformat';
import { ProcessosJudiciaisRecursoDesdobramentoService } from 'src/app/services/processos-judiciais-recurso-desdobramento.service';
import { ModalOcorrenciaComponent } from 'src/app/views/operacionais/processos-judiciais/processos-judiciais-detalhes/modal-ocorrencia/modal-ocorrencia.component';
import { Observable, Subject } from 'rxjs';
import { ResultadoModal } from 'src/app/services/shared/resultado-modal';
import { ProcessosJudiciaisOcorrenciaEventoService } from 'src/app/services/processos-judiciais-ocorrencia-evento.service';
import { ProcessosJudiciaisOcorrenciaTarefaService } from 'src/app/services/processos-judiciais-ocorrencia-tarefa.service';
import { ProcessosJudiciaisOcorrenciaPrazoService } from 'src/app/services/processos-judiciais-ocorrencia-prazo.service';
import { ProcessosJudiciaisOcorrenciaAudienciaService } from 'src/app/services/processos-judiciais-ocorrencia-audiencia.service';
import { ProcessosJudiciaisHistoricoManualService } from 'src/app/services/processos-judiciais-historico-manual.service';
import Swal from 'sweetalert2';
import { ModalConcluirAtividadeComponent } from './modal-concluir-atividade/modal-concluir-atividade.component';
import { isThisTypeNode } from 'typescript';
import { Router } from '@angular/router';
import { ModalDetalheComponent } from '../agenda/modal-detalhe/modal-detalhe.component';
import { AuthService } from 'src/app/auth/auth.service';
import { AppService } from 'src/app/app.service';
import { TipoStatusAtividade } from 'src/app/enums/atividade/tipo-status-atividade.enum';

@Component({
    selector: 'app-area-trabalho-dashboard',
    templateUrl: './area-trabalho.component.html',
    styleUrls: ['./area-trabalho.component.scss'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter }
    ],
    encapsulation: ViewEncapsulation.None
})
export class AreaTrabalhoDashboardComponent implements OnInit {


    @Output() changeRefresh: EventEmitter<boolean> = new EventEmitter<boolean>();
    public resultConfirmDialog$ = new Subject<ResultadoModal>();

    public exibirFiltro: boolean = false;
    public tiposSelecionados: number[] = [];
    public tiposDeVinculoSelecionados: string[] = [];

    public filter: any = {
        asc: false,
        campoSort: 'dataCriacao',
        quantidade: 1000,
        pagina: 0
    }

    sortDesc: boolean = false;

    dataHeaderFilter = [];
    filtersAppliedHeader = [];

    dataHeaderFilter2 = [];
    constructor(
        private processosJudiciaisOcorrenciasService: ProcessosJudiciaisOcorrenciasService,
        private processosJudiciaisService: ProcessosJudiciaisService,
        private spinner: NgxSpinnerService,
        public toastrService: ToastrService,
        private modalService: ModalService,
        private ngbModal: NgbModal,
        private processosJudiciaisOcorrenciaTarefaService: ProcessosJudiciaisOcorrenciaTarefaService,
        private processosJudiciaisOcorrenciaEventoService: ProcessosJudiciaisOcorrenciaEventoService,
        private processosJudiciaisOcorrenciaPrazoService: ProcessosJudiciaisOcorrenciaPrazoService,
        private processosJudiciaisOcorrenciaAudienciaService: ProcessosJudiciaisOcorrenciaAudienciaService,
        private processosJudiciaisHistoricoManualService: ProcessosJudiciaisHistoricoManualService,
        private processosJudiciaisRecursoDesdobramentoService: ProcessosJudiciaisRecursoDesdobramentoService,
        private router: Router,
        private authService: AuthService,
        private appService: AppService
    ) {
        this.appService.pageTitle = 'Área de trabalho';
    }

    public swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-padrao btn-lg mr-3',
            cancelButton: 'btn btn-default btn-lg'
        },
        buttonsStyling: false
    });

    public tarefas: any;
    public tarefasPrincipal: any;
    public tarefasRevisao: any;
    public tarefasExibir: any;
    public tarefasExibirMinhas: any = [];
    public tarefasExibirOutros: any = [];
    public tarefasOriginal = [];
    public loadAtividadesDoProcesso: boolean = false;
    public filtroRevisaoAtivo: boolean = false;
    public quantidadeAtividadesNaoConcluida: number = 0;
    public quantidadeAtividadesConcluida: number = 0;
    public quantidadeAtividadesEmAtraso: number = 0;
    public quantidadeTarefas: number = 0;
    public quantidadePrazo: number = 0;
    public quantidadeEvento: number = 0;
    public quantidadeAudiencia: number = 0;
    public quantidadeHistorico: number = 0;
    public exibirGrafico: boolean = true;
    public barChartOptions: ChartOptions = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                labels: {
                    color: 'rgb(255, 99, 132)'
                }
            }
        }
    };
    public barChartLabels: Label[] = ['Tarefa', 'Evento', 'Prazo', 'Audiência'];
    public barChartType: ChartType = 'horizontalBar';
    public barChartLegend = false;
    public barChartPlugins = [];
    public barChartData: ChartDataSets[] = [
        {
            data: [this.quantidadeTarefas, this.quantidadeEvento, this.quantidadePrazo, this.quantidadeAudiencia],
        }
    ];

    public tipoAtividade: string = 'responsavel';

    public dataInicialFiltroComponent: any;
    public dataFinalFiltroComponent: any;


    public options = [
        {
            label: 'Hoje',
            id: 'H'
        },
        {
            label: 'Esta semana',
            id: 'ES'
        },
        {
            label: 'Este mês',
            id: 'EM'
        },
        {
            label: 'Últimos 7 dias',
            id: '7'
        },
        {
            label: 'Últimas 30 dias',
            id: '30'
        },
        {
            label: 'Próximos 3 dias',
            id: '3'
        },
        {
            label: 'Próxima semana',
            id: 'PS'
        },
        {
            label: 'Próximo mês',
            id: 'PM'
        },
    ];

    selectedOption = 'ES';

    situacoes = [
        {
            id: 'nao-iniciada',
            label: 'Não iniciada',
            value: '1'
        },
        {
            id: 'em-execucao',
            label: 'Em execução',
            value: '2'
        },
        {
            id: 'em-revisao',
            label: 'Em revisão',
            value: '3'
        },
        {
            id: 'devolvida-para-ajustes',
            label: 'Devolvida para ajustes',
            value: '4'
        },
        {
            id: 'revisado-e-liberado',
            label: 'Revisado e liberado',
            value: '5'
        },
        {
            id: 'concluida',
            label: 'Concluída (protocolo)',
            value: '7'
        },
        {
            id: 'encerrado',
            label: 'Encerrado',
            value: '8'
        }
    ];

    textoFiltro;
    selectedTagFilter;

    ngOnInit(): void {
        this.tipoAtividade = null;
        this.buscarTarefaDoUsuario();
        // this.carregarMais();
        // this.limparFiltros();
    }

    goToGridView() {
        sessionStorage.setItem('openMenu', JSON.stringify(false));
        //this.router.navigate(['/dashboard/atividades-usuario']);
        window.location.href = '/dashboard/atividades-usuario';
    }

    changeOption() {
        // switch(this.selectedOption) {
        //     case 'H':
        //         this.tarefasExibir = this.tarefasOriginal.filter(t => new Date().toDateString() === new Date(t.dataOcorrencia).toDateString())
        //         break;
        // }
    }

    isRevisorOrAssistenteOrExecutor() {
        return this.authService.getPerfil() === 'Revisor' || this.authService.getPerfil() === 'Assistente' || this.authService.getPerfil() === 'Executor';
    }

    changeDateFilterOption(param) {
        if (this.selectedTagFilter === param.id) {
            this.selectedTagFilter = null;
            this.dataInicialFiltroComponent = null;
            this.dataFinalFiltroComponent = null;
            return;
        }
        this.selectedTagFilter = param.id;
        const currentDate = new Date();
        switch (param.id) {
            case 'H':
                this.setDateComponent(currentDate, 'dataInicialFiltroComponent');
                this.setDateComponent(currentDate, 'dataFinalFiltroComponent');
                break;

            case '7':
                this.setDateComponent(currentDate, 'dataFinalFiltroComponent');
                this.setDateComponent(this.sumDaysOnDate(-7), 'dataInicialFiltroComponent');
                break;

            case '3':
                this.setDateComponent(currentDate, 'dataInicialFiltroComponent');
                this.setDateComponent(this.sumDaysOnDate(3), 'dataFinalFiltroComponent');
                break;

            case '30':
                this.setDateComponent(currentDate, 'dataFinalFiltroComponent');
                this.setDateComponent(this.sumDaysOnDate(-30), 'dataInicialFiltroComponent');
                break;

            case 'PM':
                this.setDateComponent(this.nextMonth(), 'dataInicialFiltroComponent');
                this.setDateComponent(this.nextMonth(false, 2), 'dataFinalFiltroComponent');
                break;

            case 'EM':
                this.setDateComponent(this.nextMonth(true, 0), 'dataInicialFiltroComponent');
                this.setDateComponent(this.nextMonth(false, 1), 'dataFinalFiltroComponent');
                break;

            case 'PS':
                this.setDateComponent(this.addWeeks(new Date(), 1), 'dataInicialFiltroComponent');
                this.setDateComponent(this.addWeeks(new Date(), 1, false), 'dataFinalFiltroComponent');
                break;

            case 'ES':
                this.setDateComponent(this.thisWeek(), 'dataInicialFiltroComponent');
                this.setDateComponent(this.thisWeek(false), 'dataFinalFiltroComponent');
                break;


        }
    }

    thisWeek(beginningWeek: boolean = true) {
        const date = new Date();
        date.setDate((date.getDate() + (beginningWeek ? 0 : 7)) - date.getDay());
        return date;
    }

    addWeeks(date: Date, weeks: number, beginningWeek: boolean = true) {
        date.setDate(((date.getDate() + (beginningWeek ? 7 : 14)) - date.getDay()) * weeks || 1);
        return date;
    }

    nextMonth(beginningMonth = true, qtdMonths: number = 1) {
        const date = new Date();
        date.setMonth(date.getMonth() + qtdMonths);
        date.setDate(beginningMonth ? 1 : 0);
        return date;
    }

    sumDaysOnDate(qtdDays: number, date: Date = new Date()) {
        date.setDate(date.getDate() + qtdDays);
        return date;
    }

    setDateComponent(date: Date, field: string) {
        const formatDate = {
            year: date.getFullYear(),
            month: date.getMonth() + 1,
            day: date.getDate(),
        };
        this[field] = formatDate;
    }

    dataHeaders() {
        this.dataHeaderFilter2 = [
            {
                onFilter: () => this.filtrarAtividadesPorStatus('atividadesEmDia', 'Atividades em dia'),
                value: this.filtrarAtividadesPorStatus('atividadesEmDia', null),
                label: 'Atividades em dia'
            },
            {
                onFilter: () => this.filtrarAtividadesPorStatus('emAtrasoDataRevisao', 'Data revisão atrasado'),
                value: this.filtrarAtividadesPorStatus('emAtrasoDataRevisao', null),
                label: 'Data revisão atrasado',
                showAlert: true
            },
            {
                onFilter: () => this.filtrarAtividadesPorStatus('emAtrasoDataLimite', 'Data limite atrasado'),
                value: this.filtrarAtividadesPorStatus('emAtrasoDataLimite', null),
                label: 'Data limite atrasado',
                showAlert: true
            },
        ];

        this.dataHeaderFilter = [
            {
                onFilter: () => this.filtrarPorSituacao(1, 'Não iniciada'),
                value: this.filtrarPorSituacao(1),
                label: 'Não iniciada'
            },
            {
                onFilter: () => this.filtrarPorSituacao(2, 'Em execução'),
                value: this.filtrarPorSituacao(2),
                label: 'Em execução'
            },
            {
                onFilter: () => this.filtrarPorSituacao(3, 'Em revisão'),
                value: this.filtrarPorSituacao(3),
                label: 'Em revisão'
            },
            {
                onFilter: () => this.filtrarPorSituacao(4, 'Devolvida para ajustes'),
                value: this.filtrarPorSituacao(4),
                label: 'Devolvida para ajustes'
            },
            {
                onFilter: () => this.filtrarPorSituacao(5, 'Revisado e liberado'),
                value: this.filtrarPorSituacao(5),
                label: 'Revisado e liberado'
            },
            {
                onFilter: () => this.filtrarPorSituacao(7, 'Atividades concluídas'),
                value: this.filtrarPorSituacao(7),
                label: 'Atividades concluídas'
            },
        ]
    }

    filtrarPorSituacao(tipoStatusAtividade, label = null) {
        /** quando não tem label, retorna apenas a quantidade de items do tipoStatusAtividade*/
        if (!label) return this.tarefasOriginal.filter(item => item.tipoStatusAtividade == tipoStatusAtividade).length;
        /** */

        this.applyFilterHeader(tipoStatusAtividade, label, 'status');
    }

    filtrarAtividadesPorStatus(field, label = null) {
        let tarefasFiltradas = this.tarefasOriginal;

        let dataAtual = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate() - 1, 23, 59, 59).toISOString();

        console.log(dataAtual);

        switch (field) {
            case 'atividadesEmDia':
                tarefasFiltradas = this.filtrarAtividadesEmDia();
                break;
            case 'emAtrasoDataRevisao':
                tarefasFiltradas = this.filtrarAtrasoDataRevisao();
                break;
            case 'emAtrasoDataLimite':
                tarefasFiltradas = this.filtrarAtrasoDataLimite();
                break;
        }

        if (!label) return tarefasFiltradas.length;

        this.applyFilterHeader(field, label, 'date');
    }

    filtrarAtividadesEmDia() {
        return this.tarefasOriginal.filter(item => (item.corAlertaDataLimite != 'badge-danger' || item.hasOwnProperty('dataRevisao') && item.corAlertaDataRevisao != 'badge-danger'));
    }

    filtrarAtrasoDataRevisao() {
        return this.tarefasOriginal.filter(item => item.hasOwnProperty('dataRevisao') && item.corAlertaDataRevisao == 'badge-danger' && +item.tipoStatusAtividade < 3);
    }

    filtrarAtrasoDataLimite() {
        console.log(this.tarefasOriginal);
        return this.tarefasOriginal.filter(item => item.corAlertaDataLimite == 'badge-danger' && +item.tipoStatusAtividade < 6);
    }

    filtrarPorTipoVinculo(tipoDeVinculo: string, label: string): void {

        if (!this.adicionarRemoverFiltroTipoVinculo(tipoDeVinculo)) return;

        if (this.tiposDeVinculoSelecionados.length == 0) {
            // this.buscarTarefaDoUsuario();
            return;
        }

        this.spinner.show();

        this.applyFilterHeader(tipoDeVinculo, label, 'vinculo');

        this.quantidades();

        this.spinner.hide();
    }

    filtrarPorTipo(tipo: number, label: string): void {
        if (!this.adicionarRemoverFiltroTipo(tipo)) return;

        if (this.tiposSelecionados.length == 0) {
            // this.buscarTarefaDoUsuario();
            return;
        }

        this.spinner.show();

        this.applyFilterHeader(tipo, label, 'tipo');

        this.quantidades();

        this.spinner.hide();
    }

    applyFilterHeader(id?, label?, typeFilter?) {
        const filterStorage = JSON.parse(localStorage.getItem('area-trabalho-filters-applied-header'));
        this.filtersAppliedHeader = id !== 'fromDelete' && filterStorage ? filterStorage : this.filtersAppliedHeader;

        const alreadyExist = this.filtersAppliedHeader.some(item => item.id === id && item.typeFilter === typeFilter);
        if (id && label && !alreadyExist) {
            this.filtersAppliedHeader.push({ id, label, typeFilter });

            localStorage.setItem('area-trabalho-filters-applied-header', JSON.stringify(this.filtersAppliedHeader));
        }

        if (!this.filtersAppliedHeader.length) {
            this.tarefasExibir = this.tarefasOriginal;
        } else {
            this.executeFilters();
        }

        this.atualizarTarefasExibir();
    }

    executeFilters() {
        /** filtro por situação */
        const ids = this.filtersAppliedHeader.filter(item => item.typeFilter === 'status').map(item => item.id);
        if (ids.length) {
            this.tarefasExibir = this.tarefasOriginal.filter(original => !!ids.includes(original.tipoStatusAtividade));
        } else {
            this.tarefasExibir = this.tarefasOriginal;
        }

        /** filtro por data */
        const situacoes = this.filtersAppliedHeader.filter(item => item.typeFilter === 'date').map(item => item.id);
        const dataAtual = new Date().toISOString();

        if (situacoes.length) {
            let arr = [];
            situacoes.forEach(field => {
                switch (field) {
                    case 'atividadesEmDia':
                        arr = arr.concat(this.filtrarAtividadesEmDia());
                        break;
                    case 'emAtrasoDataRevisao':
                        arr = arr.concat(this.filtrarAtrasoDataRevisao());
                        break;
                    case 'emAtrasoDataLimite':
                        arr = arr.concat(this.filtrarAtrasoDataLimite());
                        break;
                }
            });
            this.tarefasExibir = arr;
        }

        /** filtro por tipo de vinculo na atividade */
        const vinculos = this.filtersAppliedHeader.filter(item => item.typeFilter === 'vinculo');
        if (vinculos.length) {
            let arr = [];

            vinculos.forEach(field => {
                arr = arr.concat(this.tarefasOriginal.filter(c => this.tiposDeVinculoSelecionados.includes(field.id) && c[`is${field.label}`]));
            });
            this.tarefasExibir = arr;
        }

        /** filtro por tipo */
        const tipos = this.filtersAppliedHeader.filter(item => item.typeFilter === 'tipo').map(item => item.id);;
        if (!!tipos.length) {
            this.tarefasExibir = this.tarefasOriginal.filter(original => !!tipos.includes(original.tipoOcorrencia));
        }
    }

    removeFilterApplied(id, tipo) {
        this.filtersAppliedHeader = this.filtersAppliedHeader.filter(f => f.id !== id)

        if (tipo === 'tipo') {
            this.adicionarRemoverFiltroTipo(id, true);
        }
        if (tipo === 'vinculo') {
            this.adicionarRemoverFiltroTipoVinculo(id, true);
        }
        localStorage.setItem('area-trabalho-filters-applied-header', JSON.stringify(this.filtersAppliedHeader));
        this.applyFilterHeader('fromDelete');
    }

    private loadTarefas = false;
    buscarTarefaDoUsuario() {
        this.loadTarefas = true;
        this.filtroRevisaoAtivo = false;
        this.exibirFiltro = false;
        this.spinner.show();
        this.toastrService.clear();
        this.loadAtividadesDoProcesso = true;
        this.processosJudiciaisService.getTarefasDoUsuarioFiltro(this.filter)
            .subscribe(res => {
                res.data = res.data.filter(tarefa => tarefa.tipoStatusAtividade !== TipoStatusAtividade.Encerrado);
                if (this.tarefas == undefined) {
                    this.tarefas = res.data;
                    this.tarefasOriginal = res.data;
                    this.loadTarefas = false;
                } else {
                    let inseridos = 0;
                    res.data.forEach(item => {
                        let filter = this.tarefas.filter(c => c.id == item.id);

                        if (filter.length == 0) {
                            inseridos++;
                            this.tarefas.push(item);
                            this.tarefasOriginal.push(item);
                        }
                    });
                    this.loadTarefas = false;

                    // if(inseridos == 0){
                    //     this.toastrService.error("Não foram localizados mais dados!");
                    // }
                    // this.tarefas = this.tarefas.concat(res.data);
                    // this.tarefasOriginal = this.tarefas.concat(res.data);
                }
                this.tarefas = this.tarefas.sort(function (a, b) { return <any>new Date(a.dataLimite) - <any>new Date(b.dataLimite) });
                this.tarefasOriginal = this.tarefasOriginal.sort(function (a, b) { return <any>new Date(a.dataLimite) - <any>new Date(b.dataLimite) });

                this.dataHeaders();

                this.filter.pagina += 1;
                this.tarefas.forEach(c => {

                    c.editarDetalhes = false;

                    if (c.responsavelNome && c.responsavelNome.length > 17)
                        c.responsavelNome = c.responsavelNome.substring(0, 14) + '...';

                });

                this.tarefasOriginal = this.tarefas;
                this.filtrarAtividades();
                this.tarefasExibir = this.tarefas;
                this.quantidades();
                this.spinner.hide();
                this.applyFilterHeader();

            }, error => {
                if (error && error.errors) {
                    this.toastrService.error(error.errors[0], 'Atenção', { timeOut: 10000 });
                }
                else {
                    this.toastrService.error('Não foi possível carregar os dados!', 'Atenção', { timeOut: 10000 });
                }
                this.spinner.hide();
            });

        this.loadAtividadesDoProcesso = false;
    }

    detalhesExibirOcultar(atividade: any) {
        atividade.editarDetalhes = !atividade.editarDetalhes;
    }

    clickModalTarefa(tarefa: any) {
        this.modalService.abrirModalTarefa(tarefa);
    }

    onChangeQuantidade(atividade: any, ocultar: boolean, quantidadeComentarios: number) {

        atividade.editarDetalhes = !ocultar;
        atividade.quantidadeComentarios = quantidadeComentarios;
    }

    concluirAtividade(item: any) {
        const modalRef = this.ngbModal.open(ModalConcluirAtividadeComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false
        });

        modalRef.componentInstance.modalRef = modalRef;
        modalRef.componentInstance.page = 'processo-judiciais-detalhes';
        modalRef.componentInstance.concluirItem(item);


        modalRef.result.then(result => {
            this.resultConfirmDialog$.next(result);
            console.log('concluir atividades');
            this.buscarTarefaDoUsuario();
            this.changeRefresh.emit(true);
        }).catch(error => { });
    }

    changeTipo($event) {
        console.log('changeTipo');
        this.buscarTarefaDoUsuario();
    }

    filtrarAtividades(field: string = null, isGet = false) {
        if (!field) return;
        const filter = this.tarefasOriginal.filter(t => t[field]);
        if (isGet) return filter.length;
        this.spinner.show();
        this.tarefasExibir = filter;
        this.spinner.hide();
    }

    refreshPage(){
        window.location.reload();
    }

    quantidades() {
        this.quantidadeAtividadesNaoConcluida = this.tarefasOriginal.filter(x => !x.concluido && !x.emAtraso).length;
        this.quantidadeAtividadesConcluida = this.tarefasOriginal.filter(x => x.concluido).length;
        this.quantidadeAtividadesEmAtraso = this.tarefasOriginal.filter(x => !x.concluido && x.emAtraso).length;
        this.quantidadeTarefas = this.tarefasOriginal.filter(x => x.tipoOcorrencia == 1).length;
        this.quantidadeHistorico = this.tarefasOriginal.filter(x => x.tipoOcorrencia == 2).length;
        this.quantidadeEvento = this.tarefasOriginal.filter(x => x.tipoOcorrencia == 3).length;
        this.quantidadePrazo = this.tarefasOriginal.filter(x => x.tipoOcorrencia == 4).length;
        this.quantidadeAudiencia = this.tarefasOriginal.filter(x => x.tipoOcorrencia == 5).length;

        this.dataHeaderFilter[0].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 1).length;
        this.dataHeaderFilter[1].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 2).length;
        this.dataHeaderFilter[2].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 3).length;
        this.dataHeaderFilter[3].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 4).length;
        this.dataHeaderFilter[4].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 5).length;
        this.dataHeaderFilter[5].value = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 7).length;

        this.dataHeaderFilter2[0].value = this.filtrarAtividadesPorStatus('atividadesEmDia');
        this.dataHeaderFilter2[1].value = this.filtrarAtividadesPorStatus('emAtrasoDataRevisao');
        this.dataHeaderFilter2[2].value = this.filtrarAtividadesPorStatus('emAtrasoDataLimite');

        this.barChartData = [
            {
                data: [this.quantidadeTarefas, this.quantidadeEvento, this.quantidadePrazo, this.quantidadeAudiencia
                    , this.quantidadeHistorico],
            }
        ];

        this.atualizarTarefasExibir();
    }

    atualizarTarefasExibir() {

        this.tarefasExibirMinhas = this.tarefasExibir.filter(c => c.isEdit);
        this.tarefasExibirOutros = this.tarefasExibir.filter(c => !c.isEdit);


        //mocando fotos envolvidos
        this.tarefasExibirMinhas.forEach((_, i) => {
            this.tarefasExibirMinhas[i] = {
                ...this.tarefasExibirMinhas[i],
                envolvidos: [{ img: 'https://img.ibxk.com.br/2019/02/17/17124052466014.jpg?ims=328x' }, { img: 'https://cajamar.sp.gov.br/noticias/wp-content/uploads/sites/2/2021/08/site-vacinacao-26-anos.png' }, { img: 'data:image/jpeg;base64,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' }],
            }
        });

        this.tarefasExibirOutros.forEach((_, i) => {
            this.tarefasExibirOutros[i] = {
                ...this.tarefasExibirOutros[i],
                envolvidos: [{ img: 'https://img.ibxk.com.br/2019/02/17/17124052466014.jpg?ims=328x' }, { img: 'https://cajamar.sp.gov.br/noticias/wp-content/uploads/sites/2/2021/08/site-vacinacao-26-anos.png' }, { img: 'data:image/jpeg;base64,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' }],
            }
        });
    }

    filtrarAtividadesConcluidas() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.concluido);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarAtividadesAtasadas() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => !x.concluido && x.emAtraso);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarAtividadesAConcluir() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => !x.concluido && !x.emAtraso);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarNaoIniciada() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 1);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarEmExecucao() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 2);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarEmRevisao() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 3);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarDevolvidaParaAjustes() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 4);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarRevisadoLiberado() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 5);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarConcluido() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 6 || x.tipoStatusAtividade == 7);
        this.quantidades();
        this.spinner.hide();
    }

    filtrarEncerrado() {
        this.spinner.show();
        this.tarefasExibir = this.tarefasOriginal.filter(x => x.tipoStatusAtividade == 8);
        this.quantidades();
        this.spinner.hide();
    }

    recarregar(item: any) {
        //this.limparFiltros();\
        if (item.tipoOcorrencia != 1 && item.tipoOcorrencia != 3 && item.tipoOcorrencia != 4 && item.tipoOcorrencia != 5) {
            this.spinner.hide();
        } else {

            let request: Observable<any>;

            switch (item.tipoOcorrencia) {
                case 1:
                    request = this.processosJudiciaisOcorrenciaTarefaService.obterDetalhesPorId(item.id);
                    break;
                case 3:
                    request = this.processosJudiciaisOcorrenciaEventoService.obterDetalhesPorId(item.id);
                    break;
                case 4:
                    request = this.processosJudiciaisOcorrenciaPrazoService.obterDetalhesPorId(item.id);
                    break;
                case 5:
                    request = this.processosJudiciaisOcorrenciaAudienciaService.obterDetalhesPorId(item.id);
                    break;
            }

            request.subscribe(res => {
                
                let atividades = this.tarefasExibirMinhas.filter(c => c.id == item.id);
                console.log(res.data);
                console.log(atividades);
                if (atividades.length == 0) {
                    atividades = this.tarefasExibirOutros.filter(c => c.id == item.id);
                
                    if (atividades.length != 0) {
                        let atividade = atividades[0];
                        
                        this.modificarStatusCard(atividade, res.data);
                        
                        if(atividade.isEdit){
                            this.tarefasExibirOutros = this.tarefasExibirOutros.filter(c => c.id != item.id);

                            this.tarefasExibirMinhas.push(atividade);
                        }
                    }
                }else{
                    if (atividades.length != 0) {
                        let atividade = atividades[0];
                        
                        this.modificarStatusCard(atividade, res.data);
                        
                        if(!atividade.isEdit){
                            this.tarefasExibirMinhas = this.tarefasExibirMinhas.filter(c => c.id != item.id);

                            this.tarefasExibirOutros.push(atividade);
                        }
                    }
                }
                
                this.spinner.hide();

            }, error => {
                this.toastrService.error("Não foi possível atualizar!");
            })
        }
    }

    modificarStatusCard(atividade:any, data:any){        
        atividade.tipoStatusAtividade = data.tipoStatusAtividade;
        atividade.tipoStatusAtividadeNome = data.tipoStatusAtividadeNome;
        atividade.isEdit = data.isEdit;
        atividade.quantidadeComentarios = data.quantidadeComentarios;
        atividade.dataRevisao = data.dataRevisao;
        atividade.dataLimite = data.dataLimite;
        atividade.corAlertaDataLimite = data.corAlertaDataLimite;
        atividade.corAlertaDataRevisao = data.corAlertaDataRevisao;
        atividade.dataTarefa = data.dataTarefa
        atividade.corAlertaData = data.corAlertaData;
    }

    onSearchChange(texto: string) {

        this.spinner.show();

        if (texto) {

            this.tarefasExibir = this.tarefasOriginal.filter(x =>
                (x.tituloDescricao && x.tituloDescricao.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.tipoObjeto && x.tipoObjeto.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.classificacaoAtividadeNome && x.classificacaoAtividadeNome.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.classificacaoSubtipoAtividadeNome && x.classificacaoSubtipoAtividadeNome.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.tipoStatusAtividadeNome && x.tipoStatusAtividadeNome.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.dataTarefa && this.formatarData(x.dataTarefa).includes(texto))
                || (x.dataLimite && this.formatarData(x.dataLimite).includes(texto))
                || (x.dataRevisao && this.formatarData(x.dataRevisao).includes(texto))
                || (x.processoJudicialNumero && x.processoJudicialNumero.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.processoJudicialPasta && x.processoJudicialPasta.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.codExterno && x.codExterno.toString().toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
                || (x.atuacao && x.atuacao.toLowerCase().indexOf(texto.toLocaleLowerCase()) !== -1)
            );
        } else {

            this.tarefasExibir = this.tarefasOriginal;
        }

        this.quantidades();
        this.spinner.hide();
    }

    limparBusca() {
        this.tarefas = undefined;
        this.filter = {
            asc: false,
            campoSort: 'dataCriacao',
            quantidade: 1000,
            pagina: 0
        };
    }

    limparFiltros() {
        this.selectedTagFilter = null;
        this.exibirFiltro = false;
        this.dataFinalFiltroComponent = null;
        this.dataInicialFiltroComponent = null;
        this.filter.status = null;
        this.limparBusca();
        this.filtersAppliedHeader = [];
        this.tiposSelecionados = [];
        this.tiposDeVinculoSelecionados = [];
        localStorage.removeItem('area-trabalho-filters-applied-header');

        this.buscarTarefaDoUsuario();
    }

    carregarMais() {
        this.buscarTarefaDoUsuario();
    }

    aplicarFiltros() {
        this.exibirFiltro = false;
        this.limparBusca();

        if (this.dataInicialFiltroComponent != null) {
            this.filter.dataInicio = new Date(this.dataInicialFiltroComponent.year, this.dataInicialFiltroComponent.month - 1, this.dataInicialFiltroComponent.day);
        }

        if (this.dataFinalFiltroComponent != null) {
            this.filter.dataFim = new Date(this.dataFinalFiltroComponent.year, this.dataFinalFiltroComponent.month - 1, this.dataFinalFiltroComponent.day);
        }
        console.log('aplicarFiltros');

        this.buscarTarefaDoUsuario();
    }

    gerenciarSelecaoFiltroTipo(tipo: number): string {

        return this.tiposSelecionados.find(x => x === tipo) ? 'fas fa-check-square' : 'far fa-square'
    }

    adicionarRemoverFiltroTipo(tipo: number, forcedRemove: boolean = false): boolean {

        const index = this.tiposSelecionados.find(x => x === tipo);
        console.log("this", this.tiposSelecionados)
        if (index) {

            this.tiposSelecionados = this.tiposSelecionados.filter(x => x !== tipo);
            this.removeFilterApplied(tipo, 'tipo');
            this.quantidades();
            return false;
        }
        if (!forcedRemove)
            this.tiposSelecionados.push(tipo);

        this.quantidades();
        return true;
    }

    gerenciarSelecaoFiltroTipoVinculo(tipoDeVinculo: string): string {


        return this.tiposDeVinculoSelecionados.find(x => x === tipoDeVinculo) ? 'fas fa-check-square' : 'far fa-square'
    }

    adicionarRemoverFiltroTipoVinculo(tipoDeVinculo: string, forcedRemove: boolean = false): boolean {

        const index = this.tiposDeVinculoSelecionados.find(x => x === tipoDeVinculo);

        if (index) {

            this.tiposDeVinculoSelecionados = this.tiposDeVinculoSelecionados.filter(x => x !== tipoDeVinculo);
            this.removeFilterApplied(tipoDeVinculo, 'vinculo');
            this.quantidades();
            return false;
        }
        if (!forcedRemove)
            this.tiposDeVinculoSelecionados.push(tipoDeVinculo);

        this.quantidades();
        return true;
    }

    formatarData(data) {

        const date = new Date(data);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    ordenarDados() {

        this.sortDesc = !this.sortDesc;

        this.sort(this.tarefasExibirOutros);
        this.sort(this.tarefasExibirMinhas);
    }

    sort(data: any) {

        data.sort((a: any, b: any) => {

            var sortByA = a.hasOwnProperty('dataLimite') ? 'dataLimite' : 'dataTarefa';
            var sortByB = b.hasOwnProperty('dataLimite') ? 'dataLimite' : 'dataTarefa';

            a = (new Date(a[sortByA]));
            b = (new Date(b[sortByB]));

            if (a < b) { return this.sortDesc ? 1 : -1; }
            if (a > b) { return this.sortDesc ? -1 : 1; }
            return 0;
        });
    }
}
